<template>
  <form-template @send-data="sendData" :mode="mode" @delete-data="deleteData">
    <v-text-field
      class="required"
      v-model="input.name"
      :rules="rules.name"
      label="Schicht-Name"
    ></v-text-field>
    <v-text-field
      class="required"
      v-model="input.start"
      label="Start-Uhrzeit"
      type="time"
      :rules="rules.start"
    ></v-text-field>
    <v-text-field
      class="required"
      v-model="input.end"
      label="End-Uhrzeit"
      type="time"
      :rules="rules.end"
    ></v-text-field>
    <v-checkbox
      v-model="input.flextime"
      label="Gleitzeit (Arbeitsbeginn bei Ankunft)"
      hint="Bei Fixschichten wird die Wartezeit bis Schichtbeginn zur Wegzeit hinzugerechnet."
      persistent-hint
    ></v-checkbox>
    <p><span style="color: red">*</span> notwendige Eingabe</p>
    <br />
  </form-template>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import FormTemplate from "./FormTemplate.vue";
import { mapStores } from "pinia";
import { useOfficeStore } from "../../store/officeStore";

// dev-Notes:
// --> Rules for start and end (use utils-function to keep code readable).
export default defineComponent({
  data() {
    return {
      valid: true,
      input: {
        name: "" as string,
        start: "" as string,
        end: "" as string,
        flextime: false as boolean,
      },
      rules: {
        name: [
          (val: string) => {
            if (!val) {
              return "Name notwendig.";
            }
            return val.length > 0 || "Name notwendig.";
          },
        ],
        start: [
          (val: string) => {
            if (!val) {
              return "Uhrzeit notwendig.";
            }
            return val.length > 0 || "Uhrzeit notwenig.";
          },
        ],
        end: [
          (val: string) => {
            if (!val) {
              return "Uhrzeit notwendig.";
            }
            return val.length > 0 || "Uhrzeit notwendig.";
          },
        ],
      },
    };
  },
  mounted() {
    // @ts-ignore
    if (this.mode === "put") {
      // @ts-ignore
      this.input.name = this.name;
      // @ts-ignore
      this.input.start = this.start;
      // @ts-ignore
      this.input.end = this.end;
      // @ts-ignore
      this.input.flextime = this.flextime ?? false;
    } else {
      for (let key in this.input) {
        // @ts-ignore
        this.input[key] = null;
      }
      this.input.flextime = false;
    }
  },
  components: { FormTemplate },
  computed: {
    ...mapStores(useOfficeStore),
  },
  watch: {
    mode(newVal) {
      console.log("mode changed to: ", newVal);
      if (newVal === "put") {
        // @ts-ignore
        this.valid = true;
        this.input.name = this.name ?? "";
        this.input.start = this.start ?? "";
        this.input.end = this.end ?? "";
        this.input.flextime = this.flextime ?? false;
      } else {
        for (let key in this.input) {
          // @ts-ignore
          this.input[key] = null;
        }
        this.input.flextime = false;
      }
    },
  },
  emits: {
    // validation happens within the forms
    "post-shift": () => {
      return true;
    },
    "put-shift": () => {
      return true;
    },
    "delete-shift": () => {
      return true;
    },
  },
  props: {
    name: {
      type: String as PropType<string | null>,
      default: null,
      required: false,
    },
    start: {
      type: String as PropType<string | null>,
      default: null,
      required: false,
    },
    end: {
      type: String as PropType<string | null>,
      default: null,
      required: false,
    },
    flextime: {
      type: Boolean as PropType<boolean | null>,
      default: false,
      required: false,
    },
    mode: {
      type: String as PropType<"post" | "put">,
      required: true,
    },
    currentId: {
      type: Number as PropType<number | null>,
      required: false,
      default: null,
    },
    officeId: {
      type: Number as PropType<number | null>,
      required: false,
      default: null,
    },
  },
  created() {
    // Somehow typscript does not register props. Hence the "ts-ignore".

    // @ts-ignore
    if (this.name) {
      // @ts-ignore
      this.input.name = this.name;
    }
    // @ts-ignore
    if (this.start) {
      // @ts-ignore
      this.input.start = this.start;
    }
    // @ts-ignore
    if (this.end) {
      // @ts-ignore
      this.input.end = this.end;
    }
    // @ts-ignore
    this.input.flextime = this.flextime ?? false;
  },
  methods: {
    async sendData() {
      console.log("sendData is called.");
      // fetch input data
      let shift = {
        name: this.input.name,
        start: this.input.start,
        end: this.input.end,
        flextime: !!this.input.flextime,
      };
      // @ts-ignore
      if (!this.officeId) {
        console.warn(
          "send-data stopped proceeding due to office id not being set, but required.",
        );
        return;
      }
      // depending on mode post or put
      // @ts-ignore
      if (this.mode === "post") {
        try {
          // @ts-ignore
          await this.officeStore.postShift(shift, this.officeId);
          console.log("post-shift emitted");
          this.$emit("post-shift");
        } catch (e) {
          console.warn(
            // @ts-ignore
            `post-operation could not finish. Error with message ${e.message}`,
          );
          return;
        }
        // @ts-ignore
      } else if (this.mode === "put") {
        // @ts-ignore
        if (!this.currentId) {
          console.warn(
            "put-shift-operation stoped perceeding, due to currentId not beeing set",
          );
          return;
        }
        try {
          // @ts-ignore
          await this.officeStore.putShift(this.currentId, shift, this.officeId);
          this.$emit("put-shift");
        } catch (e) {
          console.warn(
            // @ts-ignore
            `Put-shift-operation could not finish. Error with message: ${e.message} thrown.`,
          );
          return;
        }
      }
    },
    async deleteData() {
      // @ts-ignore
      if (!(this.currentId && this.officeId)) {
        console.warn(
          "delete-shift-operation did not execute, currentId or officeId prop was not set",
        );
        return;
      }
      try {
        // @ts-ignore
        await this.officeStore.deleteShift(this.currentId, this.officeId);
        this.$emit("delete-shift");
      } catch (e) {
        console.warn(
          // @ts-ignore
          `delete-shift-operation could not finish. Error with message: ${e.message} thrown.`,
        );
      }
    },
  },
});
</script>

<style>
.required label::after {
  content: " *";
  color: red;
}
</style>
